import { render, staticRenderFns } from "./AccrualsWorkspaceHeader.vue?vue&type=template&id=0e6c0886&scoped=true"
import script from "./AccrualsWorkspaceHeader.vue?vue&type=script&lang=js"
export * from "./AccrualsWorkspaceHeader.vue?vue&type=script&lang=js"
import style0 from "./AccrualsWorkspaceHeader.vue?vue&type=style&index=0&id=0e6c0886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c0886",
  null
  
)

export default component.exports